import { View } from '@/interfaces/view';
import { AttachmentModule } from '../attachment/attachment.module';

/**
 * Moduł załączników dokumentó
 *
 * @export
 * @class DocumentAttachmentModule
 * @extends {AttachmentModule}
 */
export class DocumentAttachmentModule extends AttachmentModule {
  constructor() {
    super();
    this.state = {
      ...this.state,
      avaialbleViews: []
    } as any;

    this.mutations = {
      ...this.mutations,

      /**
       * Zapisuje dostępne widoki
       *
       * @param {*} localState
       * @param {View[]} views
       */
      saveAvailableViews(localState: any, views: View[]): void {
        localState.avaialbleViews = views;
      }
    };

    this.actions = {
      ...this.actions,

      /**
       * Pobiera listę dostępnych do pobrania widoków
       *
       * @param {*} context
       * @param {*} variables
       * @returns {Promise<View[]>}
       */
      getAvailableViews: (context: any, variables: any): Promise<View[]> =>
        this.resource.viewsAvailableToDownload(variables).then(views => {
          context.commit('saveAvailableViews', views);
          return views;
        })
    };
  }
}

export default new DocumentAttachmentModule();
